// Dependencies
import styled from 'styled-components';

const OfficesStyles = styled.section`
  text-align: center;

  .offices {
    margin: 5rem 0;
    text-align: left;

    .office {
      margin: 0 0 1.2rem;
      padding: 2rem 2rem 2.5rem;
      background-color: var(--color-sand);

      .top {
        margin: 0 0 2rem;

        .location-name {
          font-weight: var(--font-weight-regular);
        }
      }

      .address-wrap {
        width: 100%;

        .address {
          margin: 0;
          padding: 0;
          list-style: none;
        }
      }

      .contact-wrap {
        width: 100%;
        display: flex;
        flex-direction: column;
        margin: 0 0 1.5rem;

        .email,
        .phone,
        .website {
          display: flex;
          align-items: center;
          margin: 0 0 0.2rem;
          word-break: break-all;

          .icon {
            width: 1.2rem;
            height: 1.2rem;
            margin: 0 0.5rem 0 0;
            transition: 0.4s fill;
          }

          &:hover,
          &:focus {
            .icon {
              fill: var(--color-graphite);
            }
          }
        }
      }
    }
  }

  .btn {
    margin: 1rem auto 0;
  }

  .office-map {
    display: flex;
    width: 100%;
    height: 20rem;
    margin: 0 auto;
    padding: 0 1rem 0;
    pointer-events: none;

    & > * {
      width: 100%;
      height: 100%;
      pointer-events: none;
    }

    .jvectormap-zoomin,
    .jvectormap-zoomout {
      display: none;
    }

    .jvectormap-marker {
      transform: translateY(-15px);
    }
  }

  @media (min-width: 768px) {
    .text {
      p {
        max-width: 50rem;
        margin: 0 auto;
      }
    }

    .offices {
      display: grid;
      gap: 1.2rem;
      grid-template-columns: 1fr 1fr;
      align-items: ${(props) => (props?.filtered ? 'center' : 'initial')};

      .office {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        align-content: flex-start;
        margin: 0;

        .top {
          width: 100%;
          margin: 0 0 1rem;
        }

        .address-wrap {
          padding: 0 1.5rem 0 0;

          .address .line {
            font-size: 0.8rem;
          }
        }

        .contact-wrap {
          .email,
          .website,
          .phone {
            font-size: 0.8rem;
          }
        }
      }
    }

    .office-map {
      height: 25rem;
      padding: 2rem;
    }
  }

  @media (min-width: 992px) {
    .offices {
      max-width: 85rem;
      margin: 5rem auto;

      .office {
        .address-wrap {
          order: 1;
          width: 45%;
        }

        .contact-wrap {
          order: 2;
          width: 55%;
        }
      }
    }
  }

  @media (min-width: 1400px) {
    .offices {
      .office {
        .address-wrap {
          .address .line {
            font-size: 1rem;
          }
        }

        .contact-wrap {
          .email,
          .website,
          .phone {
            font-size: 1rem;
          }
        }
      }
    }
  }
`;

export default OfficesStyles;
